export default __webpack_public_path__ + "static/media/flop-equity-rangevsrange_0019_thumb.51e4f582.jpg";